import { render, staticRenderFns } from "./PlanningCalendarPage.vue?vue&type=template&id=21f845f0&scoped=true&"
import script from "./PlanningCalendarPage.vue?vue&type=script&lang=js&"
export * from "./PlanningCalendarPage.vue?vue&type=script&lang=js&"
import style0 from "./PlanningCalendarPage.vue?vue&type=style&index=0&id=21f845f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f845f0",
  null
  
)

export default component.exports